
// import Notice from "~/components/home/notice.vue";
import BannerTop from "~/components/home/bannerTop.vue";
import CommonTitle from "~/components/home/commonTitle.vue";
export default {
  components: {
    CommonTitle,
    BannerTop,
    // Notice
  },
  data() {
    return {
      imageList: [
        {
          id: 1,
          src: require(`@/static/images/applicationIntroduction/gend1.png`),
        }
      ],
      imgUrl: require(`@/static/images/applicationIntroduction/gend2_${this.$i18n.locale}.png`),
    }
  },
  computed: {
    contentList1() {
      let data = this.$t('Applicationintroduction.Gend.contentList1');
      return data;
    },
    contentList2() {
      let data = this.$t('Applicationintroduction.Gend.contentList2');
      return data;
    }
  },
}
